<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
    <DxToolbar class='select-group'>
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>년도 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxYearOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        #default
        location="before"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>월 : </b></div>
      </DxItem>
      <DxItem
        :options="selectBoxMonthOptions"
        location="before"
        locate-in-menu="auto"
        widget="dxSelectBox"
      />
      <DxItem
        #default
        location="after"
        locate-in-menu="never"
      >
        <div class="toolbar-label"><b>입고모드</b></div>
      </DxItem>
      <DxItem
        :options="switchOption"
        location="after"
        locate-in-menu="auto"
        widget="dxSwitch"
      />
    </DxToolbar>
    <DxPivotGrid
      ref="refPivot"
      :allow-sorting-by-summary="true"
      :allow-sorting="true"
      :allow-filtering="true"
      :allow-expand-all="true"
      :show-borders="true"
      :show-column-grand-totals="false"
      :show-row-grand-totals="true"
      :show-row-totals="false"
      :show-column-totals="true"
      :data-source="dataSource"
      :height='pivotHeight'
      @cell-prepared = 'onCellPrepared'
      @cell-click = 'onCellClick'
      @exporting="onExporting"
    >
      <DxFieldChooser
        :enabled="false"
        :height="400"
      />
      <DxExport
        :enabled="true"
        :file-name="excelTitle"
      />
    </DxPivotGrid>
    <DxPopup2
      :visible.sync="isPivotInputPopup"
      :width="600"
      :height="600"
      title="자재입고등록"
      >
        <DxDataGrid
          :data-source="hardwareList"
          :row-alternation-enabled="true"
          @row-updated="onRowBatchUpdated"
          @toolbar-preparing='onToolbarPreparingPivotPopup'
          :show-borders="true"
          height="510"
        >
          <DxKeyboardNavigation
            enter-key-direction="column"
          />
          <DxEditing
            :allow-updating="true"
            :allow-adding="false"
            :allow-deleting="false"
            :select-text-on-edit-start="true"
            mode="batch"
          />
          <DxPaging :enabled="false"/>
          <DxColumn
            data-field="seqId"
            :visible="false"
          />
          <DxColumn
            data-field="발주번호"
            :visible="false"
          />
          <DxColumn
            data-field="입고업체"
            :visible="false"
          />
          <DxColumn
            caption="고객사"
            data-field="고객사코드"
            :allow-editing="false"
          >
            <DxLookup
              :data-source="companyInfoList"
              display-expr="거래처명"
              value-expr="거래처코드"
            />
          </DxColumn>
          <DxColumn
            data-field="품번"
            :allow-editing="false"
            sort-order="asc"
          />
          <DxColumn
            data-field="품명"
            :allow-editing="false"
          />
          <DxColumn
            caption="입고수량"
            data-field="수량"
            sort-order="desc"
          />
        <dx-sorting mode="multiple" />
        <template #selected-date>
          <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px; color:blue;'>
            <b>  입고일자 : {{ selectedDate|yyyyMMdd }}</b>
          </div>
        </template>
      </DxDataGrid>
    </DxPopup2>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxColumn, DxPaging, DxEditing, DxSorting, DxLookup, DxKeyboardNavigation } from 'devextreme-vue/data-grid'
import { DxPivotGrid, DxFieldChooser, DxExport } from 'devextreme-vue/pivot-grid'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
import { DxPopup as DxPopup2 } from 'devextreme-vue/popup'

// excel
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'HardwarePurchaseInputPivotComponent',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      thisYear: null,
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      selectBoxVendorOptions: null,
      selectedDate: null,
      selectedMonth: null,
      dailyStatus: null,
      dataSource: null,
      excelTitle: null,
      pivotHeight: null,
      총합계금액: null,
      isInputPopup: false,
      isPivotInputPopup: false,
      inputData: null,
      selectedProductionCode: null,
      isInputSwitch: false,
      switchOption: {
        text: '입고모드',
        width: 60,
        type: 'default',
        value: this.isInputSwitch,
        onValueChanged: (args) => {
          this.isInputSwitch = args.value
        }
      },
      saveButtonOptions: {
        text: '저장',
        width: 120,
        class: 'DxFormButtonItem',
        type: 'default',
        onClick: (args) => {
          this.onSaveButton()
        }
      },
      purchaseInfoList: [],
      // popup in data-grid
      inputQty: null,
      selectedDay: null,
      goodsType: 'others',
      deliveryDetailListInfo: null,
      focusedRowKeyOrder: null,
      selectedCompanyCode: null,
      seqId: null,
      입고일: null,
      isBatchInputSwitch: true,
      checkBoxesMode: 'always',
      inputBtn: null,
      // pivot popup
      hardwareList: [],
      hardwareListByPartners: [],
      formInputData: null,
      isInsertEvent: false,
      selectedRowsData: [],
      listByVendorCode: [],
      // edit 설정 관련
      isIdEdit: true
    }
  },
  props: {
    pType: {
      type: String,
      default: ConstDef.구매품
    },
    materialType: {
      type: String,
      default: null
    },
    company: {
      type: String,
      default: null
    },
    selectedVendor: {
      type: String,
      default: null
    }
  },
  components: {
    Loading,
    DxPivotGrid,
    DxFieldChooser,
    DxToolbar,
    DxItem,
    DxExport,
    DxPopup2,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxSorting,
    DxLookup,
    DxKeyboardNavigation
  },
  computed: {
    isMaterialType () {
      return (this.pType === ConstDef.구매품 && this.materialType.includes(ConstDef.부자재))
    },
    selectedDateFormat () {
      let text = this.selectedDate.substring(0, 9)
      return text
    },
    selectedRowKeys () {
      return this.selectedRowsData.map((deliveryDetailListInfo) => deliveryDetailListInfo.seqId)
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.selectedDay = AppLib.getToday()
    this.companyInfoList = this.$_.sortBy(this.$store.getters.getCompanyInfo, '거래처명')
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)
    this.pivotHeight = (screen.height - 250) * 0.9
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          console.log(excelCell)
          if (excelCell._row._number === 2) {
            excelCell.style.height = 3000
          }
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
          if (AppLib.isDataCell(pivotCell) || AppLib.isTotalCell(pivotCell) || AppLib.isCostTotalCell(pivotCell)) {
            const appearance = this.getConditionalAppearance(pivotCell)
            Object.assign(excelCell, this.getExcelCellFormat(appearance))
          }
          const borderStyle = { style: 'thin', color: { argb: 'FF7E7E7E' } }
          excelCell.border = {
            bottom: borderStyle,
            left: borderStyle,
            right: borderStyle,
            top: borderStyle
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}-${this.company}.xlsx`)
        })
      })
      e.cancel = true
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.thisYear = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.$store.commit('deleteInoutList')
          this.selectedMonth = args.value
          this.$emit('refresh-input-vendor-list', `${this.thisYear + '-' + this.selectedMonth}`)
          console.log(this.selectedVendor)
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        }
      }
      this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
    },
    /* ************************* cellClick Popup **************** */
    onCellClick (e) {
      if (this.isInputSwitch) {
        if (e.area === 'data') {
          let baseDate = `${this.thisYear}-${this.selectedMonth}-01`
          if (!AppLib.isInOutCRUDable(baseDate)) {
            this.$snotify.info('현재월 기준 2달전 품목을 입고할 수 없습니다.')
            return
          }
          this.isPivotInputPopup = true
          const day = e.cell.columnPath[1] < 9 ? `0${e.cell.columnPath[1]}` : e.cell.columnPath[1]
          let date = `${this.thisYear}-${this.selectedMonth}-${day}`
          this.refreshHardList(date)
          this.selectedDate = `${date} 12:00:00`
        }
      }
      if (e.area === 'column' && e.rowIndex === 0 && e.columnIndex === 0) { e.cancel = true }
      if (e.area === 'row' && e.cell.text.indexOf('7.') < 0) { e.cancel = true }
    },
    async onRowBatchUpdated (row) {
      row.data.발생일자 = row.data.발생일자 === null ? this.selectedDate : row.data.발생일자
      row.data.마감일자 = `${this.selectedDate.substring(0, 7)}-01`
      row.data.입고업체 = this.selectedVendor
      await this.onRowCRUD(row) // insert or update or delete
    },
    /* ************************* cellClick Popup **************** */
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
      }
    },
    makeDaily (dailyStatus) {
      if (dailyStatus.length === 0) {
        this.setInitDataSource()
        return
      }
      const mDay = AppLib.getMonthLastDay(this.thisYear, this.selectedMonth)
      let timeStamp
      const tempDaily = dailyStatus[0]
      for (let i = 1; i <= mDay; i++) {
        timeStamp = AppLib.getTimestampFromformat(this.thisYear, this.selectedMonth, i)
        let where = this.$_.findWhere(dailyStatus, { 발생일: timeStamp, 품번: tempDaily.품번 })

        if (where === undefined) {
          const temp = {
            마감처: tempDaily.마감처,
            차종: tempDaily.차종,
            코드명: tempDaily.코드명,
            발생일: timeStamp,
            품명: tempDaily.품명,
            품번: tempDaily.품번,
            자재유형: tempDaily.자재유형,
            전월재고: tempDaily.전월재고,
            제품계획수량: tempDaily.제품계획수량,
            월수량: tempDaily.월수량,
            그룹수량: 0,
            금액: tempDaily.금액
          }
          console.log(temp.마감처)
          dailyStatus.push(temp)
        }
      }
      console.log(this.dailyStatus)
      this.setInitDataSource()
    },
    refreshDataGridFromParent (vendorCode) {
      this.refreshDataGrid(this.thisYear, this.selectedMonth, vendorCode)
    },
    async refreshDataGrid (year, month, vendorCode) {
      this.selectedProductionCode = null
      this.dailyStatus = this.$store.getters.getPurchaseInfoList(vendorCode)
      this.excelTitle = `${year}-${month} 하드웨어 입고현황`
      if (this.dailyStatus !== null && !this.isInsertEvent) {
        this.makeDaily(this.dailyStatus)
        this.isInsertEvent = false
      } else {
        this.isLoading = true
        const param = {
          startDate: `${year}-${month}-01`,
          endDate: `${year}-${month}-${AppLib.getMonthLastDay(year, month)} 23:59:59`,
          품목유형: this.pType,
          자재유형: this.materialType,
          거래처코드: 'ALL'
        }
        this.$_sp.runNoEncodeFindProc('spFindAllInputPivotByDateAndType', param)
          .then((data) => {
            this.isLoading = false
            this.dailyStatus = this.$_sp.MakeModel(data)
            this.$store.commit('savePurchaseInoutList', { data: this.dailyStatus, option: param })
            this.dailyStatus = this.dailyStatus.filter(item => item.입고업체 === vendorCode)
            this.makeDaily(this.dailyStatus)
            this.pivotHeight = (screen.height - 250) * 0.9
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    setInitDataSource () {
      console.log(this.dailyStatus)
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '',
            dataField: '마감처',
            area: 'row',
            width: '120',
            expanded: true
          },
          {
            caption: '',
            dataField: '차종',
            area: 'row',
            width: '40',
            expanded: true
          },
          {
            caption: '',
            dataField: '품번',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '',
            dataField: '제품계획수량',
            area: 'row',
            width: '100',
            format: '#,##0',
            expanded: true
          },
          {
            caption: '',
            dataField: '월수량',
            area: 'row',
            width: '100',
            format: '#,##0',
            expanded: true
          },
          {
            caption: '',
            dataField: '전월재고',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            dataField: '발생일',
            dataType: 'date',
            area: 'column',
            groupInterval: 'day'
          },
          {
            caption: '수량',
            dataField: '그룹수량',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.dailyStatus
      })
    },
    getExcelCellFormat ({ fill, font, bold }) {
      return {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: fill } },
        font: { color: { argb: font }, bold }
      }
    },
    getConditionalAppearance (cell) {
      if (AppLib.isCostTotalCell(cell)) {
        return { font: '001aff', fill: 'ffffff', bold: false }
      }
      if (AppLib.isTotalCell(cell)) {
        return { fill: 'F2F2F2', font: '3F3F3F', bold: true }
      }
      return { font: '000000', fill: 'ffffff' }
    },
    /* *************************** popup method 영역********************* */
    onToolbarPreparingPivotPopup (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'selected-date'
        }
      )
    },
    async onRowCRUD (row) {
      this.seqId = null
      if (row.data.발생일자 !== null && (typeof row.data.발생일자) === 'object') {
        row.data.발생일자 = row.data.발생일자.getTime()
      }
      const param = [
        {
          발생일자: row.data.발생일자,
          발주번호: AppLib.uuidSequential(),
          마감일자: row.data.마감일자,
          입출고구분: ConstDef.자재입고,
          품번: row.data.품번,
          수량: row.data.수량,
          입고업체: row.data.입고업체,
          createid: this.userInfo.userId,
          updateid: this.userInfo.userId,
          createtime: AppLib.getNow()
        }
      ]
      let storeProc = null
      let msg = null
      if (row.data.seqId !== null && row.data.seqId !== undefined) {
        if (row.data.수량 > 0) {
          storeProc = this.$_sp.runUpdateSqlProc('창고수불', ['seqId'], null, [{ seqId: row.data.seqId, 수량: row.data.수량, updatetime: AppLib.getNow(), updateid: this.userInfo.userId }])
          msg = '수정 되었습니다'
        } else {
          storeProc = this.$_sp.runDeleteSqlProc('창고수불', [{ seqId: row.data.seqId }])
          msg = '삭제 되었습니다'
        }
      } else {
        storeProc = this.$_sp.runInsertSqlProc('창고수불', null, param)
        msg = '입고처리 되었습니다.'
      }
      storeProc
        .then((data) => {
          this.$snotify.info(msg)
          this.refreshHardList(this.selectedDate)
          this.isInsertEvent = true
          this.refreshDataGrid(this.thisYear, this.selectedMonth, this.selectedVendor)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshHardList (date) {
      this.$_sp.runNoEncodeFindProc('spFindAllItemListByDateAndMaterialType', { materialType: this.materialType, date: date, vendorCode: this.selectedVendor })
        .then((data) => {
          this.hardwareList = this.$_sp.MakeModel(data)
        })
    }
  }
}
</script>

<style lang="scss">
  .dx-button{
    margin-top: 5px;
  }
</style>
